export default "__VITE_ASSET__08mRkxlI__"